// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getFairTable ({commit, state}, params) {
    let promised = request.alert('getFairTable', params)
    return promised
  },
  offlineFair ({commit, state}, id) {
    let promised = request.alert('offlineFair', id)
    return promised
  },
  releaseFair ({commit, state}, id) {
    let promised = request.alert('releaseFair', id)
    return promised
  },
  uploadFair ({commit, state}, params) {
    let promised = request.alert('uploadFair', params)
    return promised
  },
  createFair ({commit, state}, params) {
    let promised = request.alert('createFair', params)
    return promised
  },
  editFair ({commit, state}, params) {
    let promised = request.alert('editFair', params)
    return promised
  },
  getFairOptions ({commit, state}, params) {
    let promised = request.alert('getFairOptions', params)
    return promised
  },
  getFair ({commit, state}, id) {
    let promised = request.alert('getFair', id)
    return promised
  },
  deleteFair ({commit, state}, id) {
    let promised = request.alert('deleteFair', id)
    return promised
  },
  getFairPrizeNumber ({commit, state}, id) {
    let promised = request.alert('getFairPrizeNumber', id)
    return promised
  },
  getFairUserLimit ({commit, state}, params) {
    let promised = request.alert('getFairUserLimit', params)
    return promised
  },
  searchUserList ({commit, state}, params) {
    let promised = request.alert('searchUserList', params)
    return promised
  },
  getProjectTable ({commit, state}, params) {
    let promised = request.alert('getProjectTable', params)
    return promised
  },
  getProjectDetail ({commit, state}, params) {
    let promised = request.alert('getProjectDetail', params)
    return promised
  },
  getAreaChain ({commit, state}, params) {
    let promised = request.alert('getAreaChain', params)
    return promised
  },
}

// mutations
const mutations = {}

export const fair = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/fair/fair.store.js